import {winterStartMonth} from "../config/defaults"


export function getStartOfWinterDate() {
    const currentYear = new Date().getFullYear()
    return `${currentYear}-${winterStartMonth}`
}

